import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Notification from '../../models/Notification'

export interface NotificationListState extends PaginatedApiState {
  notifications?: Notification[]
}

const NotificationList = (state: NotificationListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<NotificationListState>('NOTIFICATION_LIST')(state, action)
  }
}

export default NotificationList
